export class LaboratoireAnpp {
    static jsonMap = {
        id: { key: 'id' },
        libelle: { key: 'libelle' },
        typeLibelle: { key: 'typeLibelle' },
        typeCode: { key: 'typeCode' }
    };

    id: number = undefined;
    libelle: string = undefined;
    typeLibelle: string = undefined;
    typeCode: string = undefined;
}
